import { F0ButtonToggle } from '@factorialco/f0-react'
import { FileFilled } from '@factorialco/f0-react/icons/app'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useRoom } from 'modules/meetings/lib/hooks/useRoom'

export const SidebarButton = () => {
  const { isSideBarOpen, setIsSideBarOpen } = useRoom()

  return (
    <F0ButtonToggle
      icon={FileFilled}
      label={
        isSideBarOpen
          ? i18n.t('meetings.room.control_bar.sidebar.close')
          : i18n.t('meetings.room.control_bar.sidebar.open')
      }
      onSelectedChange={() => {
        track(trackingEvents.meetings.ControlBarSideBarButton, {
          isSideBarOpen: !isSideBarOpen,
        })
        setIsSideBarOpen(!isSideBarOpen)
      }}
      size="lg"
      selected={isSideBarOpen}
    />
  )
}
